export type SPLookup = {
  id: number
  lookupField: string
}

export const hasLookupValue = (lookup: SPLookup | undefined | null): lookup is SPLookup => 
  lookup != null && lookup.id >= 0